// TODO: Move more site defaults here, or abstract out to other places, or refactor env variables
import type { SiteLang, Environment } from '~/types/env'

export interface SiteDefaults {
  cookieDomain: string
  cookieRoot: string
  idCookieName: string
  defaultSlug: string
  donationServices: {
    phone?: string
    email: string
  }
  campaignServices: {
    email: string
  }
}

export const siteDefaultConf = {
  sv: {
    cookieDomain: 'djurensratt.se',
    cookieRoot: 'djurensratt',
    defaultSlug: 'standard-act-sv',
    donationServices: {
      phone: '08-555 914 40',
      email: 'givarservice@djurensratt.se',
    },
    campaignServices: {
      email: 'givarservice@djurensratt.se',
    },
  },
  en: {
    cookieDomain: 'project1882.org',
    cookieRoot: 'project1882',
    defaultSlug: 'standard-1882-eng',
    donationServices: {
      phone: '',
      email: 'donations@project1882.org',
    },
    campaignServices: {
      email: 'hello@project1882.org',
    },
  },
  uk: {
    cookieDomain: 'project1882.org',
    cookieRoot: 'project1882',
    defaultSlug: 'standard-1882-ukr',
    donationServices: {
      phone: '',
      email: 'donations@project1882.org',
    },
    campaignServices: {
      email: 'ua@project1882.org',
    },
  },
  es: {
    cookieDomain: 'project1882.org',
    cookieRoot: 'project1882',
    defaultSlug: 'standard-1882-spa',
    donationServices: {
      phone: '',
      email: 'donations@project1882.org',
    },
    campaignServices: {
      email: 'hello@project1882.org',
    },
  },
  fi: {
    cookieDomain: 'project1882.org',
    cookieRoot: 'project1882',
    defaultSlug: 'standard-1882-fin',
    donationServices: {
      phone: '',
      email: 'donations@project1882.org',
    },
    campaignServices: {
      email: 'hello@project1882.org',
    },
  },
} as const

export const getSiteDefaults = ({
  lang,
  env,
}: {
  lang: SiteLang
  env: Environment
}): SiteDefaults => {
  return {
    ...siteDefaultConf[lang],
    idCookieName: `${siteDefaultConf[lang]?.cookieRoot}_remember_me`,
    ...{ cookieDomain: env === 'dev' ? 'localhost' : siteDefaultConf[lang]?.cookieDomain }, // fix dev cookie domains
  }
}

/**
 * The `gava` entry a /gava path serves. The bare path is the site's standard, and on stod (sv) so is
 * `standard`: that 2019 entry is retired, and links to /gava/standard should get today's form.
 */
export function gavaSlug(param: string | string[] | undefined, lang: SiteLang, env: Environment) {
  const slug = Array.isArray(param) ? param.join('/') : param
  const { defaultSlug } = getSiteDefaults({ lang, env })
  return !slug || (slug === 'standard' && lang === 'sv') ? defaultSlug : slug
}
